/**
 * Application version information
 * Format: MAJOR.MINOR.PATCH
 * 
 * MAJOR: Breaking changes
 * MINOR: New features, non-breaking
 * PATCH: Bug fixes, non-breaking
 */

export const VERSION = {
  MAJOR: 1,
  MINOR: 3,
  PATCH: 49,
} as const;

// Debug version for tracking beta releases during development
// Increment this number with each small change to ensure browser cache refresh
// Format: YYYYMMDD.N where N is the iteration number for that day
// This will be removed when going to production
export const DEBUG_VERSION = "20250623.2"; // v1.3.49 - Fixed TypeScript errors for Loveable

export const IS_BETA = false;
export const IS_DEVELOPMENT = import.meta.env.DEV;

export const getVersionString = (): string => {
  const baseVersion = `${VERSION.MAJOR}.${VERSION.MINOR}.${VERSION.PATCH}`;
  // Temporarily always show debug version to verify changes are syncing
  // TODO: Change back to IS_DEVELOPMENT check before production
  if (DEBUG_VERSION) {
    return `${baseVersion}-beta.${DEBUG_VERSION}`;
  }
  return baseVersion;
};

export const getFullVersionInfo = (): string => {
  return `v${getVersionString()} (${new Date().toISOString().split('T')[0]})`;
};
